import { queryOptions, useQuery, useSuspenseQuery } from '@tanstack/react-query'
import { checkCarWithDVLA, getCar, getCars, getPossibleCars } from './api'

export const carsQueryOptions = () =>
    queryOptions({
        queryKey: ['cars'],
        queryFn: () => getCars(),
    })

export function useCars() {
    return useQuery(carsQueryOptions())
}

export function useCarsSuspense() {
    return useSuspenseQuery(carsQueryOptions())
}

export const carQueryOptions = (carId: string, ownerType: 'student' | 'staff' | 'visitor') =>
    queryOptions({
        queryKey: ['car', carId, ownerType],
        queryFn: () => getCar(carId, ownerType),
    })

export function useCar(carId: string, ownerType: 'student' | 'staff' | 'visitor') {
    return useQuery(carQueryOptions(carId, ownerType))
}

export function useCarSuspense(carId: string, ownerType: 'student' | 'staff' | 'visitor') {
    return useSuspenseQuery(carQueryOptions(carId, ownerType))
}

export const possibleCarsQueryOptions = (searchQuery: string) =>
    queryOptions({
        queryKey: ['possibleCars', searchQuery],
        queryFn: () => getPossibleCars(searchQuery),
    })

export function usePossibleCars(searchQuery: string) {
    return useQuery(possibleCarsQueryOptions(searchQuery))
}

export function usePossibleCarsSuspense(searchQuery: string) {
    return useSuspenseQuery(possibleCarsQueryOptions(searchQuery))
}

export const carDvlaQueryOptions = (reg: string) =>
    queryOptions({
        queryKey: ['cars', 'dvla-check', reg],
        queryFn: () => checkCarWithDVLA(reg),
    })

export function useCarDvla(reg: string, enabled = true) {
    return useQuery({
        ...carDvlaQueryOptions(reg),
        enabled,
    })
}

export function useCarDvlaSuspense(reg: string) {
    return useSuspenseQuery(carDvlaQueryOptions(reg))
}

